import React, { useEffect } from "react";

import "./Home.css";

import { ReactComponent as TituloHome } from "../../assets/home/conecta-peru-center.svg";
import { ReactComponent as SubtituloHome } from "../../assets/home/subtitulohome.svg";

import compite from "../../assets/home/compite.svg";
import expresate from "../../assets/home/expresate.svg";
import crea from "../../assets/home/crea.svg";
import diviertete from "../../assets/home/diviertete.svg";
import conectate from "../../assets/home/conectate.svg";

import icono_carac_grupo from "../../assets/home/icono_carac_grupo.svg";
import iconoevento_1 from "../../assets/home/evento_1.png";
import iconoevento_2 from "../../assets/home/evento_2.png";
import iconoevento_3 from "../../assets/home/evento_3.png";

import videoFondo from "../../assets/home/conectateperu.mp4";

function Home() {
  const coloresCirculos = [
    "#00C2FF", // celeste
    "#97C100", // verde
    "#FF2D52", // rosado
    "#FFC700", // amarillo
    "#FF6B00", // naranja
    "#A259FF", // violeta
  ];
  const inicialesUsuarios = ["I", "A", "E"];
  function getColor(idx) {
    return coloresCirculos[idx % coloresCirculos.length];
  }

  useEffect(() => {
    const header = document.querySelector(".home-header");
    const onScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div>
      <section className="home-hero position-relative text-center text-white d-flex flex-column">
        {/* Video de fondo */}
        <video
          className="home-hero-bg"
          src={videoFondo}
          autoPlay
          loop
          muted
          playsInline
        />

        {/* Contenedor para título y subtítulo encima del video */}
        <div className="home-hero-header w-100">
          <TituloHome className="home-title" />
          <SubtituloHome className="home-subtitle mt-3" />
        </div>

        {/* Contenedor para texto debajo del video */}
        <div className="home-hero-text mx-auto mt-3">
          <p className="lead home-description">
            Nuestro propósito es brindarte un espacio de conexión y encuentro
            con personas de interés similares, donde podrás participar en todo
            tipo de eventos y actividades, nutrir tu talento literario, aprender
            un nuevo idioma o practicar tu deporte favorito, las posibilidades
            son infinitas. Aquí fomentamos la diversidad y la conexión entre
            todo tipo de personas, y todo esto en un espacio seguro y de
            bienestar.
            <br />
            <br />
            Unirte a nuestra comunidad es simple, todo lo que necesitas es
            registrarte en nuestra web, explorar los grupos disponibles y
            empezar a participar en actividades que más te interesen. Además si
            tienes una idea para un grupo o evento, puedes crearlo fácilmente y
            nosotros te ayudaremos a encontrar participantes adecuados.
          </p>
          <h3 className="mt-4 text-color97C100 fw-bold">
            Bienvenido a nuestra Comunidad
            <br />
            ¡Conéctate!
          </h3>
        </div>
      </section>

      {/* Buscador de eventos */}
      <section className="container">
        <form
          className="buscador-amplio input-group shadow-sm mx-auto position_relativa"
          style={{ maxWidth: 600 }}
        >
          <span className="input-group-text bg-white border-0">
            <i className="bi bi-search text-muted"></i>
          </span>
          <input
            className="form-control border-0"
            type="search"
            placeholder="Buscar evento"
            aria-label="Buscar evento"
            style={{ background: "#fff" }}
          />
          <button className="btn btn-danger px-4" type="submit">
            Buscar
          </button>
        </form>
        <div className="text-center mt-3">
          <button className="btn btn-dark">Quiero unirme</button>
        </div>
      </section>

      {/* Planes para hoy */}
      <section className="container my-5">
        <h2 className="text-center mb-4 tituloplaneshoy">
          ¿Qué planes para hoy?
        </h2>
        <div className="row justify-content-center">
          <div className="col-6 col-md-2 mb-3 text-center">
            <img src={compite} alt="Compite" className="img-fluid rounded" />

            <div className="mt-2 subtituloplaneshoy">Compite</div>
          </div>
          <div className="col-6 col-md-2 mb-3 text-center">
            <img
              src={expresate}
              alt="Exprésate"
              className="img-fluid rounded"
            />
            <div className="mt-2 subtituloplaneshoy">Exprésate</div>
          </div>
          <div className="col-6 col-md-2 mb-3 text-center">
            <img src={crea} alt="Crea" className="img-fluid rounded" />
            <div className="mt-2 subtituloplaneshoy">Crea</div>
          </div>
          <div className="col-6 col-md-2 mb-3 text-center">
            <img
              src={diviertete}
              alt="Diviértete"
              className="img-fluid rounded"
            />
            <div className="mt-2 subtituloplaneshoy">Diviértete</div>
          </div>
          <div className="col-6 col-md-2 mb-3 text-center">
            <img
              src={conectate}
              alt="Conéctate"
              className="img-fluid rounded"
            />
            <div className="mt-2 subtituloplaneshoy">Conéctate</div>
          </div>
        </div>
      </section>

      {/* Buscador de grupos */}

      <section className="container mb-4">
        <form
          className="buscador-amplio input-group shadow-sm mx-auto position_relativa"
          style={{ maxWidth: 600 }}
        >
          <span className="input-group-text bg-white border-0">
            <i className="bi bi-search text-muted"></i>
          </span>
          <input
            className="form-control border-0"
            type="search"
            placeholder="Busca tu grupo"
            aria-label="Buscar grupo"
            style={{ background: "#fff" }}
          />
          <button className="btn btn-danger px-4" type="submit">
            Buscar
          </button>
        </form>
      </section>

      {/* Características */}
      <section className="container mb-5">
        <div className="row justify-content-center">
          <div className="col-10 col-md-8 col-lg-4">
            <ul className="list-unstyled m-0 p-0">
              <li className="mb-4">
                <div className="d-flex align-items-center gap-3">
                  <img src={icono_carac_grupo} alt="" width={60} height={60} />
                  <span className="fs-5 fw-medium caracteristica-texto">
                    Tendrás la posibilidad de crear tu propio grupo y eventos.
                  </span>
                </div>
              </li>
              <li className="mb-4">
                <div className="d-flex align-items-center gap-3">
                  <img src={icono_carac_grupo} alt="" width={60} height={60} />
                  <span className="fs-5 fw-medium caracteristica-texto">
                    Diversidad de actividades de todo y para todos.
                  </span>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-center gap-3">
                  <img src={icono_carac_grupo} alt="" width={60} height={60} />
                  <span className="fs-5 fw-medium caracteristica-texto">
                    Espacio ideal para encontrar tu "Tribu", conectarte en línea
                    o en persona.
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Eventos del día */}
      <section className="container mb-5">
        <div className="row align-items-center mb-3">
          <div className="col-6">
            <h3 className="tituloeventosdeldia mb-0">Eventos del día</h3>
          </div>
          <div className="col-6 text-end">
            <a href="/eventos" className="eventosdeldiavermas">
              Ver más
            </a>
          </div>
        </div>
        <div className="row g-4">
          <div className="col-12 col-md-4">
            <div className="evento-card p-3 h-100 d-flex flex-column align-items-center">
              <img
                src={iconoevento_1}
                className="evento-img mb-3"
                alt="Muestra teatral El Quijote"
              />
              <div className="w-100">
                <div className="evento-fecha text-muted small mb-1">
                  15 de agosto 2023 | 18:40 pm
                </div>
                <h5 className="evento-titulo mb-2">
                  Muestra teatral El Quijote
                </h5>

                <div className="d-flex align-items-center mb-1">
                  {inicialesUsuarios.map((letra, idx) => (
                    <span
                      key={idx}
                      className="badge-circulo"
                      style={{
                        backgroundColor: getColor(idx),
                        marginRight:
                          idx < inicialesUsuarios.length - 1 ? "-6px" : "8px",
                        zIndex: inicialesUsuarios.length - idx,
                      }}
                    >
                      {letra}
                    </span>
                  ))}
                  <span className="masasistentes text-muted small ms-2">
                    120 asistentes
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="evento-card p-3 h-100 d-flex flex-column align-items-center">
              <img
                src={iconoevento_2}
                className="evento-img mb-3"
                alt="Muestra teatral El Quijote"
              />
              <div className="w-100">
                <div className="evento-fecha text-muted small mb-1">
                  15 de agosto 2023 | 18:40 pm
                </div>
                <h5 className="evento-titulo mb-2">
                  Muestra teatral El Quijote
                </h5>
                <div className="d-flex align-items-center mb-1">
                  {inicialesUsuarios.map((letra, idx) => (
                    <span
                      key={idx}
                      className="badge-circulo"
                      style={{
                        backgroundColor: getColor(idx),
                        marginRight:
                          idx < inicialesUsuarios.length - 1 ? "-6px" : "8px",
                        zIndex: inicialesUsuarios.length - idx,
                      }}
                    >
                      {letra}
                    </span>
                  ))}
                  <span className="masasistentes text-muted small ms-2">
                    120 asistentes
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="evento-card p-3 h-100 d-flex flex-column align-items-center">
              <img
                src={iconoevento_3}
                className="evento-img mb-3"
                alt="Muestra teatral El Quijote"
              />
              <div className="w-100">
                <div className="evento-fecha text-muted small mb-1">
                  15 de agosto 2023 | 18:40 pm
                </div>
                <h5 className="evento-titulo mb-2">
                  Muestra teatral El Quijote
                </h5>
                <div className="d-flex align-items-center mb-1">
                  {inicialesUsuarios.map((letra, idx) => (
                    <span
                      key={idx}
                      className="badge-circulo"
                      style={{
                        backgroundColor: getColor(idx),
                        marginRight:
                          idx < inicialesUsuarios.length - 1 ? "-6px" : "8px",
                        zIndex: inicialesUsuarios.length - idx,
                      }}
                    >
                      {letra}
                    </span>
                  ))}
                  <span className="masasistentes text-muted small ms-2">
                    120 asistentes
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
    </div>
  );
}

export default Home;
